import type { AgentType } from '@paladin-monorepo/common';

export type LlmChatSessionsQueryFilters = {
  inquiryId?: string;
  agentType?: AgentType;
};

export function llmChatSessionsQueryKey(filters?: LlmChatSessionsQueryFilters) {
  return ['llm-chat-sessions', filters ?? {}] as const;
}
